import { Box, TablePagination } from '@mui/material';

const MuiTablePagination = ({ totalCount, ...props }) => {
    return (
        <TablePagination
            component="div"
            {...props}
            labelDisplayedRows={({ from, to, count }) => {
                return (
                    <>
                        Showing{' '}
                        <Box
                            component="span"
                            className="blue-text"
                        >
                            {from}-{to}
                        </Box>{' '}
                        of {count} results {count !== totalCount ? `(${totalCount} unfiltered)` : null}
                    </>
                );
            }}
        />
    );
};

export default MuiTablePagination;
